import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { SvgIconService } from '../../services/svg-icon.service';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { Subscription } from 'rxjs';
import { CommonDataPassService } from '../../services/common-data-pass.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-clear-cart-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './clear-cart-info.component.html',
  styleUrl: './clear-cart-info.component.scss'
})
export class ClearCartInfoComponent implements OnInit {
  icons = inject(SvgIconService).icons
  cookie = inject(SsrCookieService)
  commonDataPass = inject(CommonDataPassService)
  router = inject(Router)
  showModal:boolean = false;eventSlug:string = '';modalType:null | string = null
  openModalSub!:Subscription
  ngOnInit(): void {
      this.openModalSub = this.commonDataPass.clearCartInfo$.subscribe((res:any) =>{
        this.showModal = res?.open
        this.eventSlug = res?.eventSlug
        this.modalType = res?.data
      });
  }

  goBack(){
    this.cookie.delete('cartDetails','/')
    if (this.commonDataPass.getReturnUrl()) {
      this.commonDataPass.routeToExternalUrl()
    } else {
      this.commonDataPass.routeTo(this.eventSlug, 'event')
    }
    this.showModal = false
  }

  close(){
        this.showModal = false
        this.modalType = null
  }

}
